import React from 'react';
import parse from 'html-react-parser';
import renderPatternDetection from '../search/renderPatternDetection';
import renderSuggestions from '../search/renderSuggestions';
import renderLearningPlan from '../search/renderLearningPlan';
import renderEnhancedAnalysis from '../search/renderEnhancedAnalysis';
import MarkdownText from '../search/MarkdownText';

const ChatMessage = ({ message, isLast, onFollowUp }) => {
  const isUser = message.role === 'user';
  const { structured_data, response_type } = message;

  const renderStructuredContent = () => {
    if (!structured_data) return null;

    const data = {
      ...structured_data,
      analysis: structured_data.analysis || '',
      type: response_type
    };

    return (
      <div className="mt-3">
        {response_type === 'pattern_observation' && data.patterns && renderPatternDetection(data)}
        {response_type === 'behavioral_observations' && data.suggestions && renderSuggestions(data)}
        {response_type === 'self_reflection_plan' && data.plan && renderLearningPlan(data)}
        {(response_type === 'time_analysis' || response_type === 'risk_awareness' ||
          response_type === 'performance_review' || response_type === 'search') &&
          data.insights && renderEnhancedAnalysis(data)}
      </div>
    );
  };

  const renderFollowUps = () => {
    if (!isLast || !structured_data?.follow_up_suggestions?.length) return null;

    return (
      <div className="mt-3 flex flex-wrap gap-2">
        {structured_data.follow_up_suggestions.map((suggestion, idx) => (
          <button
            key={idx}
            onClick={() => onFollowUp(suggestion)}
            className="px-3 py-1.5 text-sm bg-primary/20 text-primary rounded-lg hover:bg-primary/30 transition-colors border border-primary/30"
          >
            {suggestion}
          </button>
        ))}
      </div>
    );
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-2xl rounded-lg px-4 py-2 ${
        isUser
          ? 'bg-crimson text-white'
          : 'bg-secondary text-secondary-foreground border border-border'
      }`}>
        <div className="prose prose-sm max-w-none">
          {isUser ? message.content : parse(message.content)}
        </div>
        {!isUser && renderStructuredContent()}
        {!isUser && renderFollowUps()}
      </div>
    </div>
  );
};

export default ChatMessage;
